import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

import DashboardLayout from "layouts/Dashboard.js";
import ProjectLayout from "layouts/Project.js";
import ProjectV2Layout from "layouts/ProjectV2.js";
import { ChakraProvider } from "@chakra-ui/react";

import { store } from "./store";

import theme from "theme/theme.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ChakraProvider position="relative" resetCss={false} theme={theme}>
      <HashRouter>
        <Switch>
          <Route component={DashboardLayout} path={`/dashboard`} />
          <Route component={ProjectLayout} path={`/project/:projectId`} />
          <Route component={ProjectV2Layout} path={`/v2/project/:projectId`} />
          <Redirect from={`/`} to="/dashboard" />
        </Switch>
      </HashRouter>
    </ChakraProvider>
  </Provider>,
  document.getElementById("root")
);
